import React, { useRef } from "react";
import { Box, Typography, FormLabel } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useToast } from "../toast";

export default function CognitoAiFileUploadPickerPane({ onFileSelected }) {
  const theme = useTheme();
  const filePickerInput = useRef();
  const { addToast } = useToast();

  const ALLOWED_EXTENSIONS = ["tar", "gz", "tgz", "iso"];
  const MAX_FILE_SIZE = 7 * 1024 * 1024 * 1024; // 7GB

  const validateFilePicked = (event) => {
    const selectedFile = event?.target?.files[0];

    if (!selectedFile) return;

    // Validate file extension
    const fileName = selectedFile.name.toLowerCase();
    const ext = fileName.split(".").pop();

    if (!ALLOWED_EXTENSIONS.includes(ext)) {
      addToast({
        type: "error",
        message: `Invalid file type. Allowed types: ${ALLOWED_EXTENSIONS.join(", ")}`,
        autoClose: 3000,
      });
      filePickerInput.current.value = null;
      return;
    }

    // Validate file size
    if (selectedFile.size > MAX_FILE_SIZE) {
      addToast({
        type: "error",
        message: `File size exceeds maximum allowed (7GB)`,
        autoClose: 3000,
      });
      filePickerInput.current.value = null;
      return;
    }

    if (selectedFile.size < 1024) {
      addToast({
        type: "error",
        message: `File size is too small (minimum 1KB)`,
        autoClose: 3000,
      });
      filePickerInput.current.value = null;
      return;
    }

    onFileSelected(selectedFile);
    event.target.value = "";
  };

  return (
    <div>
      <Typography sx={{ fontSize: 15, marginBottom: 2 }} color="text.primary">
        Select a Cognito AI image file to upload
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          top: 0,
          left: 0,
          height: "400px",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          border: "2px dashed",
          borderColor: grey[500],
          background: grey[200],
        }}
      >
        <FormLabel
          htmlFor="cognito-ai-file-upload"
          sx={{
            textAlign: "center",
            fontSize: 30,
            padding: 2,
            width: 300,
            borderRadius: 2,
            border: "1px solid white",
            cursor: "pointer",
            color: "#fff",
            background: theme.palette.primary[700],
            boxShadow: 10,
          }}
        >
          Upload
        </FormLabel>
      </Box>

      <Box sx={{ display: "none" }}>
        <input
          type="file"
          id="cognito-ai-file-upload"
          ref={filePickerInput}
          onInput={(e) => validateFilePicked(e)}
          accept=".tar,.gz,.tgz,.iso"
        />
      </Box>

      <Typography sx={{ fontSize: 12, marginTop: 2, color: "text.secondary" }}>
        Supported formats: TAR, GZ, TGZ, ISO | Max size: 7GB
      </Typography>
    </div>
  );
}
